import { render, staticRenderFns } from "./x-btn-fab-expander.vue?vue&type=template&id=a4e224d0&scoped=true&"
import script from "./x-btn-fab-expander.vue?vue&type=script&lang=js&"
export * from "./x-btn-fab-expander.vue?vue&type=script&lang=js&"
import style0 from "./x-btn-fab-expander.vue?vue&type=style&index=0&id=a4e224d0&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e224d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
installComponents(component, {VBtn,VChip,VIcon,VSpeedDial})
